import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import uspfiber from "../../assets/uspfiberlaser.png";

export default function UspFiberLaser() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [foodAndBeverageVisible, setFoodAndBeverageVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const foodAndBeverageRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Laser Type",
      data: "Adjustable pulse fiber laser",
    },
    {
      title: "Laser Wavelength",
      data: "1064nm",
    },
    {
      title: "Character Height",
      data: "0.8mm to allowable area",
    },
    {
      title: "Number of Lines",
      data: "Limited only by character height and allowable print area",
    },
    {
      title: "Marking Area",
      data: "50mm X 50mm, 70mm X 70mm, 110mm X 110mm, 140mm X 140mm, 175mm X 175mm, 210mm X 210mm",
    },
    {
      title: "Focal Lens",
      data: "63mm, 100mm, 163mm, 210mm, 254mm, 330mm",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "Cooling system",
      data: "Air Cooling",
    },
    {
      title: "Power",
      data: "90-264V AC, 47-63HZ, 800W",
    },
    {
      title: "Operation Environment",
      data: "-6-45°C, 10%-90%RH, non-condensing",
    },
    {
      title: "Laser Head Dimensions (L x W x H)",
      data: "640mm X 100mm X 110mm",
    },
    {
      title: "Controller Dimensions (L x W x H)",
      data: "525mm X 197mm X 325mm",
    },
    {
      title: "Reflector Size",
      data: "Standard : 8mm",
    },
  ];

  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
      pageNavigate: "/byindustry/foodandbeverage",
    },
    {
      productImg: Images?.industry1,
      label: "Automobile",
      pageNavigate: "/byindustry/automobile",
    },
    {
      productImg: Images?.industry7,
      label: "Pharma",
      pageNavigate: "/byindustry/pharma",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };

  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP FIBER LASER"
        printerImg={Images?.uspstream17}
        pdfFile={FilePdf?.usp_FIBER_LASER}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            FIBER LASER
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            The new fiber laser marking system adopt a new intelligent vector
            control algorithm, which greatly improves the marking speed. Laser
            has smaller size, lower maintenance, no consumables and provides
            permanent High-quality coding. Can be commonly used in food,
            cosmetics and other industries of flexible Packaging, hard
            plastic(PE/PP), metal and other materials to print high contrast
            logo, to ensure the traceability of the product permanently.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                // className={`youtubeVideo `}
                className={`youtubeVideo ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img className="w-[100%]" src={uspfiber} alt="" />
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.usp_FIBER_LASER}
                    download="Usp Fiber Laser"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
